function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useCallback, useRef, useState } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';
var getDimensionObject = function getDimensionObject(element) {
  var _element$getBoundingC = element.getBoundingClientRect(),
    bottom = _element$getBoundingC.bottom,
    height = _element$getBoundingC.height,
    left = _element$getBoundingC.left,
    right = _element$getBoundingC.right,
    top = _element$getBoundingC.top,
    width = _element$getBoundingC.width,
    x = _element$getBoundingC.x,
    y = _element$getBoundingC.y;
  return {
    width,
    height,
    top,
    left,
    x,
    y,
    right,
    bottom
  };
};
export var useDimensions = function useDimensions() {
  var reference = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    element = _useState2[0],
    setElement = _useState2[1];
  var _useState3 = useState({
      width: 0,
      height: 0,
      top: 0,
      left: 0,
      x: 0,
      y: 0,
      right: 0,
      bottom: 0
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    dimensions = _useState4[0],
    setDimensions = _useState4[1];
  var setRef = useCallback(function (node) {
    if (node) {
      setElement(node);
    }
    reference.current = node;
  }, []);
  useIsomorphicLayoutEffect(function () {
    if (!element) {
      return;
    }
    var measure = function measure() {
      return window.requestAnimationFrame(function () {
        return setDimensions(getDimensionObject(element));
      });
    };
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('scroll', measure);
    return function () {
      window.removeEventListener('resize', measure);
      window.removeEventListener('scroll', measure);
    };
  }, [element]);
  return {
    ref: setRef,
    dimensions
  };
};